import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useText } from "../context/ContentContext";

const heroImage =
    "https://static.prod-images.emergentagent.com/jobs/de7dd3a1-fc4e-4232-a60c-ffbb6934ff70/images/5e2ad45bedea387a0166ba7f8d2096512477547dcbc6fb4f40244267e70dd43d.png";

export default function Hero() {
    const eyebrow = useText("hero_eyebrow", "RealtorReferral.ca");
    const part1 = useText("hero_title_part1", "Find Your");
    const emphasis = useText("hero_title_emphasis", "Perfect Realtor");
    const part2 = useText("hero_title_part2", "Across Canada");
    const subtitle = useText(
        "hero_subtitle",
        "A personally vetted, human-matched real estate referral service. No bots. No bidding. Just the right agent for your move."
    );
    const cta = "Get Matched Now!";

    return (
        <section
            className="relative overflow-hidden bg-brand-paper paper-grain"
            data-testid="hero-section"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-24 lg:pt-28 lg:pb-32">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                        className="lg:col-span-7"
                    >
                        <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-6">
                            — {eyebrow}
                        </div>
                        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-brand-ink">
                            {part1}{" "}
                            <span className="italic font-normal text-brand-ink/90">
                                {emphasis}
                            </span>
                            <br />
                            {part2}
                        </h1>
                        <p className="mt-8 text-lg lg:text-xl text-brand-muted leading-relaxed max-w-xl">
                            {subtitle}
                        </p>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <Link
                                to="/get-started"
                                data-testid="hero-cta-primary"
                                className="inline-flex items-center gap-3 bg-brand-ink text-brand-paper px-8 py-4 text-sm tracking-wide hover:bg-black transition-all hover:gap-4"
                            >
                                {cta}
                                <span aria-hidden>→</span>
                            </Link>
                            <Link
                                to="/about"
                                data-testid="hero-cta-secondary"
                                className="inline-flex items-center gap-2 border border-brand-ink/15 text-brand-ink px-8 py-4 text-sm tracking-wide hover:bg-brand-sand transition-colors"
                            >
                                Meet Thom
                            </Link>
                        </div>

                        <div className="mt-16 flex flex-wrap gap-8 text-sm text-brand-muted">
                            <div>
                                <div className="font-serif text-3xl text-brand-ink">15+</div>
                                <div className="text-xs uppercase tracking-wider mt-1">Years in real estate</div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl text-brand-ink">100%</div>
                                <div className="text-xs uppercase tracking-wider mt-1">Free for clients</div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl text-brand-ink">All 10</div>
                                <div className="text-xs uppercase tracking-wider mt-1">Provinces served</div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
                        className="lg:col-span-5 relative"
                    >
                        <div className="relative image-zoom">
                            <img
                                src={heroImage}
                                alt="Modern Canadian home"
                                className="w-full h-[520px] lg:h-[640px] object-cover"
                            />
                            <div className="absolute -bottom-6 -left-6 bg-brand-paper p-6 border border-brand-line max-w-[240px] shadow-sm">
                                <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold mb-2">
                                    No cost. No catch.
                                </div>
                                <p className="text-sm text-brand-ink leading-snug">
                                    Agents pay the referral fee from their commission — never you.
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
